var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareScreenOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.72,16.66a1.85,1.85,0,0,0,.64-1.4V7.11a1.85,1.85,0,0,0-1.86-1.85h-13A1.85,1.85,0,0,0,3.63,7.11v8.15a1.85,1.85,0,0,0,.64,1.4H2v2.08H22V16.66ZM18.29,7.34V15H5.7V7.34Zm.22,9.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.24,10.23,12.74,8a.28.28,0,0,0-.3,0,.28.28,0,0,0-.16.25v.9c-.84.22-3.62,1.26-3.62,5.22a.29.29,0,0,0,.23.27h0a.27.27,0,0,0,.26-.17,3.88,3.88,0,0,1,3.08-2.58v.81a.26.26,0,0,0,.16.25.23.23,0,0,0,.11,0,.32.32,0,0,0,.19-.07l2.5-2.23a.25.25,0,0,0,.09-.2A.27.27,0,0,0,15.24,10.23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenOn);
export default __webpack_public_path__ + "static/media/share-screen-on.d1d9adbc90605230f18f79a12d1ef82b.svg";
export { ForwardRef as ReactComponent };